module.exports = __webpack_public_path__ + "static/media/1POLICY22.16c89f1f.jpg";